/**
 * Global Lenis instance — created in ScrollOnePager, exposed here so
 * DeviceFrame can stop/start scroll during full-screen expansion.
 */
import type Lenis from "lenis"

export let globalLenis: Lenis | null = null

export function setGlobalLenis(l: Lenis | null) {
  globalLenis = l
}
